// import api from "@/api";
const state = {
  requests: []
};
const getters = {
  requests: state => {
    return state.requests;
  }
};
const actions = {
  // async getRequests({ commit }, payload) {
  //   const result = await api.get(`/api/v1/inventory?${payload}`);
  //   if (result && result.status == 200) commit("setRequests", result.data.data);
  // },
  // async fetchRequest({ commit }, payload) {
  //   commit("ignore");
  //   const result = await api.get(`/api/v1/inventory?${payload}`);
  //   if (result && result.status == 200) return result.data.data[0];
  //   return null;
  // },
  // async createRequest({ commit }, payload) {
  //   commit("ignore");
  //   const result = await api.post(`/api/v1/inventory/request/`, payload);
  //   if (result && result.status == 200) return result.data.data;
  //   return null;
  // },
  // async review({ commit }, payload) {
  //   commit("ignore");
  //   const result = await api.post(
  //     "/api/v1/inventory/request/request_validation/",
  //     payload
  //   );
  //   if (result && result.status == 200) return result.data.data;
  //   return null;
  // }
};
const mutations = {
  setRequests: (state, payload) => {
    state.requests = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
